<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card card-form">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 col-md-6">
                                <div class="form-group">
                                    <label>{{$t("realEstate.field.ownerClient")}} <span class="red">*</span></label>
                                    <v-select v-model="asset.owner" label="text"
                                              :options="owners"
                                              :filterable="false"
                                              @search="onOwnerSearch"
                                              @search:focus="onOwnerFocus"
                                              :class="{invalid : $v.asset.owner.$error}">
                                        <template slot="option" slot-scope="option" v-if="option">
                                            <div v-html="option.text"></div>
                                        </template>
                                        <template slot="selected-option"
                                                  v-if="asset && asset.owner && asset.owner.text">
                                            <div v-html="asset.owner.text"
                                                 @click="$eventBus.$emit('search:focus')"></div>
                                        </template>
                                        <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                    </v-select>
                                    <div class="red" v-if="$v.asset.owner.$error">
                                        {{$t("realEstate.validation.ownerClient")}}
                                    </div>
                                </div>

                                <template v-if="isOrgTypeMib">
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.mibDebtorName")}} <span
                                                class="red">*</span></label>
                                        <input type="text" class="form-control" v-model="asset.mibDebtorName"
                                               :class="{invalid : $v.asset.mibDebtorName.$error}"/>
                                        <div class="red" v-if="$v.asset.mibDebtorName.$error">
                                            {{$t("realEstate.validation.mibDebtorName")}}
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.mibLetterNumber")}} <span
                                                class="red">*</span></label>
                                        <input type="text" class="form-control" v-model="asset.mibLetterNumber"
                                               :class="{invalid : $v.asset.mibLetterNumber.$error}"/>
                                        <div class="red" v-if="$v.asset.mibLetterNumber.$error">
                                            {{$t("realEstate.validation.mibLetterNumber")}}
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.mibLetterDate")}} <span
                                                class="red">*</span></label>
                                        <datepicker class="form-control" format="dd/MM/yyyy" v-model="mibLetterDate"
                                                    :clear-button="true"
                                                    :class="{invalid : $v.mibLetterDate.$error}"></datepicker>
                                        <div class="red" v-if="$v.mibLetterDate.$error">
                                            {{$t("realEstate.validation.mibLetterDate")}}
                                        </div>
                                    </div>
                                </template>

                                <div class="form-group">
                                    <label>{{$t("realEstate.field.evaluationPurpose")}} <span
                                            class="red">*</span></label>
                                    <select class="form-control" v-model="asset.evlGoalType"
                                            :class="{invalid : $v.asset.evlGoalType.$error}">
                                        <option :value="option.key" v-for="option in goalTypes" :key="option.key">
                                            {{option.name}}
                                        </option>
                                    </select>
                                    <div class="red" v-if="$v.asset.evlGoalType.$error">
                                        {{$t("realEstate.validation.evaluationPurpose")}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t("realEstate.field.name")}} <span class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="asset.name"
                                           :class="{invalid : $v.asset.name.$error}"/>
                                    <div class="red" v-if="$v.asset.name.$error">
                                        {{$t("realEstate.validation.name")}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="form-group">
                                    <label>{{$t("realEstate.field.propertyType")}} <span class="red">*</span></label>
                                    <select class="form-control" v-model="asset.evlPropertyType"
                                            :class="{invalid : $v.asset.evlPropertyType.$error}">
                                        <option value=""></option>
                                        <option :value="option.key" v-for="option in propertyTypes" :key="option.key">
                                            {{option.name}}
                                        </option>
                                    </select>
                                    <div class="red" v-if="$v.asset.evlPropertyType.$error">
                                        {{$t("realEstate.validation.propertyType")}}
                                    </div>
                                </div>

                                <div class="form-group" v-if="hasPermission('ASSET_ASSIGN')">
                                    <label>{{$t("realEstate.field.evaluator")}} <span class="red">*</span></label>
                                    <v-select v-model="asset.employee" label="text"
                                              :options="employees"
                                              :filterable="false"
                                              @search="onEmployeeSearch"
                                              @search:focus="onEmployeeFocus"
                                              :class="{invalid : $v.asset.employee.$error}">
                                        <template slot="option" slot-scope="option" v-if="option">
                                            <div v-html="option.text"></div>
                                        </template>
                                        <template slot="selected-option"
                                                  v-if="asset && asset.employee && asset.employee.text">
                                            <div v-html="asset.employee.text"
                                                 @click="$eventBus.$emit('search:focus')"></div>
                                        </template>
                                        <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                    </v-select>
                                    <div class="red" v-if="$v.asset.employee.$error">
                                        {{$t("realEstate.validation.evaluator")}}
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label>{{$t("realEstate.field.contractAmount")}}</label>
                                    <numeric-input class="form-control" v-model="asset.evlContractAmount"
                                                   :controls="false" :precision="2"
                                                   :disabled="isMib"></numeric-input>
                                    <span style="color: green">ҚҚС билан: {{asset.evlAmountToPay | currency('', 2, { thousandsSeparator: ' ' })}} сўм</span>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <div class="section-header">
                                    <h4>Молиявий натижалар ва Бугалтерия баланси</h4>
                                </div>
                            </div>
                            <div class="col col-12">
                                <div class="table-responsive">
                                  <div class="table-wrapper">
                                    <table class="table table-hover">
                                        <thead>
                                        <tr>
                                            <th width="80%">Номи</th>
                                            <th width="30%" class="text-center">ЖАРАЁН</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr>
                                            <td>Молиявий натижалар</td>
                                            <td class="td-actions" v-if="asset.id">
                                                <router-link tag="button"
                                                             :to="'/business/finance-result/edit/' + asset.id"
                                                             v-tooltip="'Ўзгартириш'"
                                                             class="all-btn edit-btn table-action">
                                                    <i class="fa fa-edit"></i>
                                                </router-link>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Бугалтерия баланси</td>
                                            <td v-if="asset.id" class="td-actions">
                                                <router-link tag="button"
                                                             :to="'/business/balance/edit/' + asset.id"
                                                             v-tooltip="'Ўзгартириш'"
                                                             class="all-btn edit-btn table-action">
                                                    <i class="fa fa-edit"></i>
                                                </router-link>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Бизнес режа</td>
                                            <td v-if="asset.id" class="td-actions">
                                                <router-link tag="button"
                                                             :to="'/business/business-plan/edit/' + asset.id"
                                                             v-tooltip="'Ўзгартириш'"
                                                             class="all-btn edit-btn table-action">
                                                    <i class="fa fa-edit"></i>
                                                </router-link>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Таъсисчилар</td>
                                            <td class="td-actions">
                                                <router-link tag="button"
                                                             :to="'/business/founders/edit/' + asset.id"
                                                             v-tooltip="'Ўзгартириш'"
                                                             class="all-btn edit-btn table-action">
                                                    <i class="fa fa-edit"></i>
                                                </router-link>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Хўжалик субъекти тарихи</td>
                                            <td v-if="asset.id" class="td-actions">
                                                <router-link tag="button"
                                                             :to="'/business/business-entity/edit/' + asset.id"
                                                             v-tooltip="'Ўзгартириш'"
                                                             class="all-btn edit-btn table-action">
                                                    <i class="fa fa-edit"></i>
                                                </router-link>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                  </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12">
                                <div class="section-header">
                                    <h4>{{$t("asset.assetDocs")}}</h4>
                                </div>
                            </div>
                            <template v-if="asset.owner">

                                <AssetDropZone code="documentsDropZone" :label="documentOrPassportLbl"
                                               folder="Documents" :data="asset.documents"
                                               @change="(files) => {asset.documents = files}"
                                               :has-error="$v.asset.documents.$error"
                                               :removeFile="canSave && hasPermission('ASSET_IMAGE_DELETE')"/>

                                <template v-if="isOwnerTypeLegal && isOrgTypeMib">
                                    <AssetDropZone code="actOfSaleDropZone" label="asset.actOfSale"
                                                   folder="ActOfSale" :data="asset.actOfSale"
                                                   @change="(files) => {asset.actOfSale = files}"
                                                   :has-error="$v.asset.actOfSale.$error"
                                                   :removeFile="canSave && hasPermission('ASSET_IMAGE_DELETE')"/>
                                    <AssetDropZone code="decisionDropZone" label="asset.decision"
                                                   folder="Decision" :data="asset.decision"
                                                   @change="(files) => {asset.decision = files}"
                                                   :has-error="$v.asset.decision.$error"
                                                   :removeFile="canSave && hasPermission('ASSET_IMAGE_DELETE')"/>
                                    <AssetDropZone code="playlistDropZone" label="asset.playlist"
                                                   folder="ExecutivePlaylist" :data="asset.playlist"
                                                   @change="(files) => {asset.playlist = files}"
                                                   :removeFile="canSave && hasPermission('ASSET_IMAGE_DELETE')"/>

                                </template>
                            </template>
                        </div>

                        <div class="row" v-if="asset.id && asset.id > 0">
                              <template>
                                  <PreviewDropZone code="checkPaymentDropZone" :label="checkPaymentLbl"
                                                   :data="asset.checkPaymentFiles"
                                                   @change="(files) => {asset.checkPaymentFiles = files}"
                                  />
                              </template>
                              <div class="form-check checkbox-inline">
                                  <label class="form-check-label pl-3 font-weight-bold">
                                      <input class="form-check-input" type="checkbox"
                                             v-model="asset.displayReport"
                                             @change="showReport()">
                                      <span class="form-check-sign"></span>
                                      {{$t("report.field.showReport")}}
                                  </label>
                              </div>
                        </div>

                        <div class="row">
                            <div class="col-12 btns-box">
                                <button
                                        class="all-btn pull-right btn-sm"
                                        @click="reportDocQrCode(asset)">
                                    <i v-if="loading.isDocQrLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.titleWordQrCode")}}
                                </button>
                                <button
                                        class="all-btn pull-right btn-sm"
                                        @click="reportDoc(asset)">
                                    <i v-if="loading.isDocLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.titleWord")}}
                                </button>
                                <button class="all-btn pull-right btn-sm"
                                        @click="reportPdfQrCode(asset)">
                                    <i v-if="loading.isPdfQrLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.titleQrCode")}}
                                </button>
                                <button class="all-btn pull-right btn-sm"
                                        @click="reportPdf(asset)">
                                    <i v-if="loading.isPdfLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.title")}}
                                </button>
                                <button class="all-btn pull-right btn-sm"
                                        @click="contractQrCodePdf(asset)">
                                    <i v-if="loading.isCPdfQrLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.titleContractPdfQrCode")}}
                                </button>
                                <button class="all-btn pull-right btn-sm"
                                        @click="contractPdf(asset)">
                                    <i v-if="loading.isCPdfLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.titleContractPdf")}}
                                </button>
                                <button class="all-btn pull-right btn-sm"
                                        @click="contractDocQrCode(asset)">
                                    <i v-if="loading.isCDocQrLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.titleContractWordQrCode")}}
                                </button>
                                <button class="all-btn pull-right btn-sm"
                                        @click="contractDoc(asset)">
                                    <i v-if="loading.isCDocLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.titleContractWord")}}
                                </button>
                            </div>
                        </div>

                        <div class="row" v-if="asset.id && asset.id > 0">
                            <div class="col-12">
                                <div class="section-header">
                                    <h4 class="pull-left">
                                        {{$t("asset.assetToEvaluate")}}
                                    </h4>
                                    <button class="all-btn add-btn pull-right ml-2" v-if="canSave" @click="addAsset">
                                        {{$t("asset.titleAddEdit")}}
                                    </button>
                                </div>
                                <div class="table-responsive">
                                  <div class="table-wrapper">
                                    <table class="table table-hover">
                                        <thead>
                                        <tr>
                                            <th width="5%">№</th>
                                            <th width="30%">Бино номи</th>
                                            <th width="15%">Вилоят</th>
                                            <th width="15%">Туман</th>
                                            <th width="15%">БАХОЛАНГАН ҚИЙМАТИ</th>
                                            <th width="100%">ЖАРАЁН</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(assetItem, index) in asset.assetItemDtos" :key="assetItem.id">
                                            <td>{{index+1}}</td>
                                            <td>{{assetItem.name}}</td>
                                            <td>{{assetItem.province.name}}</td>
                                            <td>{{assetItem.region.name}}</td>
                                            <td>
                                                {{assetItem.evlTotal | currency('', 0, { thousandsSeparator: ' ' })}} сўм
                                            </td>
                                            <td class="td-actions text-center direction-row">
                                                <router-link tag="button"
                                                             :to="'/asset/item/edit/' + assetItem.id"
                                                             v-tooltip="'Ўзгартириш'"
                                                             class="all-btn edit-btn table-action">
                                                    <i class="fa fa-edit"></i>
                                                </router-link>
                                                <button type="button" v-tooltip="'Ўчириш'" v-if="canSave"
                                                        class="all-btn delete-btn table-action"
                                                        @click="showDeleteAssetItemDialog(assetItem, index)">
                                                    <i class="fa fa-times"></i>
                                                </button>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                  </div>
                                </div>
                            </div>
                        </div>

                        <div class="row mt-5">
                            <div class="col-12 btns-box">
                                <button class="all-btn delete-btn" @click="cancel" :disabled="processing">
                                    {{$t("action.cancel")}}
                                </button>
                                <button class="all-btn add-btn" v-if="canSave" @click="save" :disabled="processing">
                                    {{$t("action.save")}}
                                </button>
                                <button class="all-btn" @click="changeStatus('Evaluated')"
                                        :disabled="processing" v-if="canEvaluate">{{$t("realEstate.action.evaluate")}}
                                </button>
                                <button class="all-btn add-btn" @click="changeStatus('Confirmed')"
                                        :disabled="processing" v-if="canConfirm">{{$t("realEstate.action.confirm")}}
                                </button>
                                <button class="all-btn edit-btn" @click="changeStatus('NotFullyEvaluated')"
                                        :disabled="processing" v-if="canReEvaluate">
                                    {{$t("realEstate.action.reevaluate")}}
                                </button>

                                <button class="all-btn add-btn" @click="sendReportToMIBAsset(asset)"
                                        v-if="hasPermission('SEND_TO_MIB_ASSET') && isMib && asset.status === 'Confirmed'" >
                                    {{$t("realEstate.action.sendReportToMIB")}}
                                </button>
                                <router-link
                                        tag="button"
                                        v-tooltip="'ЭЦПни тасдиқлаш'"
                                        :to="'/asset/esp/' + asset.id"
                                        class="all-btn pull-right"
                                        v-if="hasPermission('ASSET_CONFIRM') && asset.status === 'Confirmed'"
                                >
                                    {{$t("realEstate.action.espSign")}}
                                </router-link>
                            </div>
                        </div>
                        <div class="row mt-2" v-if="asset.status === 'Confirmed'">
                            <div class="col">
                                <div class="alert alert-warning d-flex">
                                    <i class="fa-fw fa fa-warning mr-1"></i>
                                    <label style="color: #4d2600; font-size: 14px"><strong>ЭЦП оркали имзолаш! </strong> Тасдиқлагандан (қайта Тасдиқлагандан сўнг хам) ЭЦПни имзоланг. ЭЦП имзолаш тугмасини босинг!</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Datepicker from 'vuejs-datepicker';
    import {numericTypes} from '@/shared/constants/mask'
    import {EVL_GOAL_TYPES, EVL_PROPERTY_TYPES} from '@/shared/constants/realEstate'
    import initFilterModel from '@/shared/filter';
    import AssetDropZone from '@/views/asset/AssetDropZone'
    import {required, requiredUnless, minLength} from 'vuelidate/lib/validators';
    import {formatDate, parseDate} from '@/shared/utils';
    import PreviewDropZone from '@/views/real-estate/PreviewDropZone'

    export default {
        name: "BusinessAddEditView",
        components: {
            AssetDropZone,
            Datepicker,
            PreviewDropZone
        },
        data() {
            return {
                processing: false,
                loading: {
                    isDocQrLoading: false,
                    isDocLoading: false,
                    isPdfLoading: false,
                    isPdfQrLoading: false,
                    isCDocLoading: false,
                    isCPdfLoading: false,
                    isCDocQrLoading: false,
                    isCPdfQrLoading: false
                },
                show: false,
                numericTypes: numericTypes,
                ownerFilter: initFilterModel(),
                employeeFilter: initFilterModel(),
                asset: {
                    id: null,
                    owner: {},
                    evlGoalType: 'Predge',
                    name: '',
                    evlContractAmount: 0,
                    employee: {},
                    evlValueType: 'Market',
                    evlPropertyType: '',

                    mibDebtorName: '',
                    mibLetterNumber: '',
                    mibLetterDate: null,
                    displayReport: false,

                    assetItemDtos: [],

                    documents: [],
                    actOfSale: [],
                    decision: [],
                    playlist: [],
                    checkPaymentFiles: [],// to'lov haqidagi hujjatlar
                    status: 'Pending'
                },
                mibLetterDate: null,
                owners: [],
                employees: [],
                goalTypes: EVL_GOAL_TYPES,
                propertyTypes: EVL_PROPERTY_TYPES
            }
        },
        validations() {
            return {
                asset: {
                    owner: {
                        required: required
                    },
                    evlGoalType: {
                        required: required
                    },
                    name: {
                        required: required
                    },
                    evlPropertyType: {
                        required: required
                    },
                    employee: {
                        id: {
                            required: required
                        }
                    },
                    documents: {
                        required: requiredUnless(() => {
                            return this.isMib;
                        }),
                        minLength: minLength(1)
                    },
                    actOfSale: {
                        required: requiredUnless(() => {
                            return !(this.isOrgTypeMib);
                        }),
                        minLength: minLength(1)
                    },
                    decision: {
                        required: requiredUnless(() => {
                            return !(this.isOrgTypeMib);
                        }),
                        minLength: minLength(1)
                    },
                    // MIB
                    mibDebtorName: {
                        required: requiredUnless(() => {
                            return !(this.isOrgTypeMib);
                        })
                    },
                    mibLetterNumber: {
                        required: requiredUnless(() => {
                            return !(this.isOrgTypeMib);
                        })
                    }
                },
                mibLetterDate: {
                    required: requiredUnless(() => {
                        return !(this.isOrgTypeMib);
                    })
                }
            };
        },
        computed: {
            isOwnerTypePhysical() {
                return !!(this.asset.owner && this.asset.owner.type && this.asset.owner.type === 'Physical');
            },
            isOwnerTypeLegal() {
                return !!(this.asset.owner && this.asset.owner.type && this.asset.owner.type === 'Legal');
            },
            isMib() {
                return !!(this.asset.owner && this.asset.owner.organizationType && this.asset.owner.organizationType === 'BUREAU_OF_COMPULSORY_EXECUTION');

            },
            isOrgTypeMib() {
                return !!(this.asset.owner &&
                    this.asset.owner.organizationType &&
                    (this.asset.owner.organizationType === 'BUREAU_OF_COMPULSORY_EXECUTION' || this.asset.owner.organizationType === 'CUSTOMS_ADMINISTRATION'));
            },
            documentOrPassportLbl() {
                if (this.asset) {
                    if (this.asset.owner && this.asset.owner.type && this.asset.owner.type === 'Legal')
                        return "asset.document";
                    else
                        return "asset.passport";
                } else {
                    return "asset.passport";
                }
            },
            canConfirm() {
                return this.asset.status === 'Evaluated';
            },
            canReEvaluate() {
                return (this.asset.status === 'Evaluated' || this.asset.status === 'Confirmed') && this.hasPermission('ASSET_REEVALUATE');
            },
            canSave() {
                return (this.asset.status === 'Pending' || this.asset.status === 'AssignedToEvaluator' || this.asset.status === 'NotFullyEvaluated');
            },
            canEvaluate() {
                return (this.asset.status === 'NotFullyEvaluated');
            },
            showReportButton() {
                return (this.asset.status === 'Evaluated' || this.asset.status === 'Confirmed') && this.asset.id && this.asset.id > 0;
            },
            sendToMIBAssetReport() {
                return (this.asset.status === 'Evaluated' || this.asset.status === 'Confirmed') && this.asset.id && this.asset.id > 0;
            },
            checkPaymentLbl() {
                return this.isOrgTypeMib ? "realEstate.field.checkPaymentFilesMib" : "realEstate.field.checkPaymentFiles";
            }
        },
        methods: {
            init() {
                const vm = this;
                const id = this.$route.params.id;

                const promises = [];
                if (id && id > 0) {
                    promises.push(this.$http.get('asset/' + id));
                    Promise.all(promises).then(function (values) {
                        if (values.length >= 0) {
                            const editData = values[0].data;
                            if (!editData.evlGoalType) {
                                editData.evlGoalType = '';
                            }

                            if (!editData.employee) {
                                editData.employee = {};
                            }
                            vm.mibLetterDate = parseDate(editData.mibLetterDate);
                            vm.asset = editData;

                        }
                    });
                }
            },
            cancel() {
                this.$router.push('/asset');
            },
            save() {
                this.saveAndGo();
            },
            saveAndGo() {

                console.log(this.$v)
                console.log(this.$v.$invalid)

                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                this.processing = true;

                if (this.mibLetterDate) {
                    this.asset.mibLetterDate = formatDate(this.mibLetterDate);
                }

                if (this.isMib) {
                    this.asset.evlContractAmount = 0;
                }

                this.$http.post('asset/save', this.asset)
                    .then(res => {

                        if (res && res.data && res.data.status === 'SUCCESS') {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('messages.realEstate.statusSuccess'),
                                type: 'success'
                            });
                            this.$router.push('/asset');
                        } else {
                            this.$swal({
                                title: this.$t('messages.common.warning'),
                                text: this.$t('messages.realEstate.statusWarning'),
                                type: 'warning'
                            });
                        }
                        this.processing = false;
                    }, () => {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('messages.realEstate.error'),
                            type: 'error'
                        });
                        this.processing = false;
                    });
            },
            addAsset() {
                this.$router.push('/asset/item/new/' + this.asset.id);
            },
            onOwnerSearch(searchTxt, loading) {
                loading(true);
                this.owners = [];
                this.ownerFilter.search = searchTxt;
                this.$http.post('customer/search', this.ownerFilter)
                    .then(res => {
                        console.log("S")
                        this.owners = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onOwnerFocus() {
                this.owners = [];
                this.ownerFilter.search = '';
                this.$http.post('customer/search', this.ownerFilter)
                    .then(res => {
                        this.owners = res.data.data;
                        console.log(res.data)
                    }, err => {
                        console.log(err);
                    });
            },
            onEmployeeSearch(searchTxt, loading) {
                loading(true);
                this.employees = [];
                this.employeeFilter.search = searchTxt;
                this.$http.post('employes/search', this.employeeFilter)
                    .then(res => {
                        this.employees = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onEmployeeFocus() {
                this.employees = [];
                this.employeeFilter.search = '';
                this.$http.post('employes/search', this.employeeFilter)
                    .then(res => {
                        this.employees = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            showDeleteAssetItemDialog(assetItem, index) {
                this.$swal({
                    title: this.$t('messages.common.warning'),
                    text: this.$t('asset.deleteConfirm'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#dd3333',
                    confirmButtonText: 'Ўчириш',
                    cancelButtonText: 'Бекор қилиш'
                }).then((result) => {
                    if (result.value) {
                        this.$http.delete('asset/item/delete/' + assetItem.id)
                            .then((res) => {
                                if (res && res.data && res.data.status === 'SUCCESS') {
                                    this.$swal({
                                        title: this.$t('messages.common.success'),
                                        text: this.$t('messages.building.deleteSuccess'),
                                        type: 'success'
                                    });
                                    this.asset.assetItemDtos.splice(index, 1);
                                } else {
                                    this.$swal({
                                        title: this.$t('messages.common.warning'),
                                        text: res.data.message,
                                        type: 'warning'
                                    });
                                }
                                this.processing = false;
                            }, () => {
                                this.$swal({
                                    title: this.$t('messages.common.error'),
                                    text: this.$t('messages.building.deleteError'),
                                    type: 'error'
                                });
                                this.processing = false;
                            });
                    }
                });
            },
            changeStatus(status) {
                this.processing = true;
                this.$http.post('asset/status', {
                    id: this.asset.id,
                    status: status,
                }).then(res => {
                    if (res && res.data && res.data.status === 'SUCCESS') {
                        this.$swal({
                            title: this.$t('messages.common.success'),
                            text: this.$t('asset.statusSuccess'),
                            type: 'success'
                        });
                        this.asset.status = status;
                        if (status === 'Confirmed') {
                            this.$router.push('/asset/esp/' + this.asset.id)
                        }
                    } else {
                        this.$swal({
                            title: this.$t('messages.common.warning'),
                            text: this.$t('asset.statusWarning'),
                            type: 'warning'
                        });
                    }
                    this.processing = false;
                }, () => {
                    this.$swal({
                        title: this.$t('messages.common.error'),
                        text: this.$t('asset.statusError'),
                        type: 'error'
                    });
                    this.processing = false;
                });
            },
            reportPdf: function (asset) {
                this.loading.isPdfLoading = true;
                this.downloadFile('/v2/businessReport/pdf/' + asset.hashUuid + '/WITH_SIGNATURE',
                    'Хисобот ' + asset.owner.fullName + '.pdf',
                    'application/pdf',
                    'isPdfLoading');
            },
            reportPdfQrCode: function (asset) {
                this.loading.isPdfQrLoading = true;
                this.downloadFile('/v2/businessReport/pdf/' + asset.hashUuid + '/WITH_QR_CODE',
                    'Хисобот ' + asset.owner.fullName + '.pdf',
                    'application/pdf',
                    'isPdfQrLoading');
            },
            reportDoc: function (asset) {
                this.loading.isDocLoading = true;
                this.downloadFile('/v2/businessReport/doc/' + asset.hashUuid + '/WITH_SIGNATURE',
                    'Хисобот ' + asset.owner.fullName + '.doc',
                    'application/doc',
                    'isDocLoading');
            },
            reportDocQrCode: function (asset) {
                this.loading.isDocQrLoading = true;
                this.downloadFile('/v2/businessReport/doc/' + asset.hashUuid + '/WITH_QR_CODE',
                    'Хисобот ' + asset.owner.fullName + '.doc',
                    'application/doc',
                    'isDocQrLoading');
            },
            downloadFile: function (url, name, type, loading) {
                this.$http.get(url, {responseType: 'arraybuffer'})
                    .then(response => {
                        let blob = new Blob([response.data], {type: type});
                        let link = document.createElement("a");
                        link.href = window.URL.createObjectURL(blob);
                        link.download = name;
                        link.click();
                        this.loading[loading] = false;
                    })
                    .catch(err => {
                        console.log(err);
                        this.loading[loading] = false;
                        if (err.response && err.response.status === 429) {
                          this.$reportSwal(err.response, () => this.downloadFile(url, name, type, loading))
                        }
                    })
            },
            contractDocQrCode: function (asset) {
                this.loading.isCDocQrLoading = true;
                this.downloadFile('/v2/assetContract/doc/' + asset.hashUuid + '/WITH_QR_CODE',
                    'Шартнома ' + asset.owner.fullName + '.doc',
                    'application/doc',
                    'isCDocQrLoading');
            },
            contractDoc: function (asset) {
                this.loading.isCDocLoading = true;
                this.downloadFile('/v2/assetContract/doc/' + asset.hashUuid + '/WITH_SIGNATURE',
                    'Шартнома ' + asset.owner.fullName + '.doc',
                    'application/doc',
                    'isCDocLoading');
            },
            contractPdf: function (asset) {
                this.loading.isCPdfLoading = true;
                this.downloadFile('/v2/assetContract/pdf/' + asset.hashUuid + '/WITH_SIGNATURE',
                    'Шартнома ' + asset.owner.fullName + '.pdf',
                    'application/pdf',
                    'isCPdfLoading');
            },
            contractQrCodePdf: function (asset) {
                this.loading.isCPdfQrLoading = true;
                this.downloadFile('/v2/assetContract/pdf/' + asset.hashUuid + '/WITH_QR_CODE',
                    'Шартнома ' + asset.owner.fullName + '.pdf',
                    'application/pdf',
                    'isCPdfQrLoading');
            },

            sendReportToMIBAsset: function (asset) {
                this.processing = true;
                this.$http.get('/sendApiMibConfirmReport/pdf/' + asset.id + '/WITH_QR_CODE/Asset', {responseType: 'arraybuffer'})
                    .then(response => {
                        if (response && response.status ===200) {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('realEstate.report.titleQrCode'),
                                type: 'success'
                            });
                        } else {
                            this.$swal({
                                title: this.$t('messages.common.warning'),
                                text: this.$t('messages.common.error'),
                                type: 'warning'
                            });
                        }
                        this.processing = false;
                    })
                    .catch(err => {
                        console.log(err);
                        this.$swal({
                            title: this.$t('messages.common.warning'),
                            text: this.$t('messages.common.error'),
                            type: 'warning'
                        });
                        this.processing = false;
                    })
            },
            showReport: function () {
                this.$http.post('asset/show-report/' + this.asset.id + '/' + this.asset.displayReport)
                    .then(res => {
                        if (res && res.data && res.data.status === 'SUCCESS') {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('messages.realEstate.showReportSuccess'),
                                type: 'success'
                            });
                            this.asset.status = status;
                        } else if (res && res.data && res.data.status === 'FAIL') {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('messages.realEstate.showCancelReportSuccess'),
                                type: 'success'
                            });
                        }
                    }, () => {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('messages.realEstate.showReportError'),
                            type: 'error'
                        });
                    });
            }

        },
        created() {
            this.init();
        }
    }
</script>

<style scoped>

</style>
